import { createFileRoute, Outlet, useMatches } from '@tanstack/react-router'
import { Header } from '@/routes/_landing/-components/header'
import { Footer } from '@/routes/_landing/-components/footer'

// Per-page chrome config, declared on each child route's `staticData` and read here.
// `landingHeader`: hero pages (index/professionals) sit `aboveBackground` (white text, transparent
// until scrolled); docs renders `relative`; legal pages use the default sticky header.
// `hideFooter`: docs is the lone full-bleed page with no footer.
type LandingStaticData = {
  landingHeader?: { aboveBackground?: boolean; className?: string }
  hideFooter?: boolean
}

export const Route = createFileRoute('/_landing')({
  component: LandingLayout,
})

function LandingLayout() {
  const matches = useMatches()
  // staticData is typed as the generic StaticDataRouteOption; assert our per-page shape.
  // oxlint-disable-next-line typescript/no-unnecessary-type-assertion
  const config = matches.at(-1)?.staticData as LandingStaticData | undefined

  return (
    <>
      <Header aboveBackground={config?.landingHeader?.aboveBackground} className={config?.landingHeader?.className} />
      <Outlet />
      {!config?.hideFooter && <Footer />}
    </>
  )
}
